import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=ba529022&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"
import style0 from "./Bills.vue?vue&type=style&index=0&id=ba529022&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba529022",
  null
  
)

export default component.exports